var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9985 5.27399C11.9585 5.26732 11.9118 5.26732 11.8718 5.27399C10.9518 5.24065 10.2185 4.48732 10.2185 3.55399C10.2185 2.60065 10.9852 1.83398 11.9385 1.83398C12.8918 1.83398 13.6585 2.60732 13.6585 3.55399C13.6518 4.48732 12.9185 5.24065 11.9985 5.27399Z",
    stroke: "#1E729F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3117 10.1274C12.2251 10.2808 13.2318 10.1208 13.9384 9.64742C14.8784 9.02076 14.8784 7.99409 13.9384 7.36743C13.2251 6.89409 12.2051 6.73409 11.2917 6.89409",
    stroke: "#1E729F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.97836 5.27399C4.01836 5.26732 4.06503 5.26732 4.10503 5.27399C5.02503 5.24065 5.75836 4.48732 5.75836 3.55399C5.75836 2.60065 4.99169 1.83398 4.03836 1.83398C3.08503 1.83398 2.31836 2.60732 2.31836 3.55399C2.32503 4.48732 3.05836 5.24065 3.97836 5.27399Z",
    stroke: "#1E729F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66492 10.1274C3.75158 10.2808 2.74492 10.1208 2.03825 9.64742C1.09825 9.02076 1.09825 7.99409 2.03825 7.36743C2.75159 6.89409 3.77158 6.73409 4.68492 6.89409",
    stroke: "#1E729F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 10.2525C7.95997 10.2458 7.9133 10.2458 7.8733 10.2525C6.9533 10.2192 6.21997 9.46583 6.21997 8.5325C6.21997 7.57917 6.98664 6.8125 7.93997 6.8125C8.8933 6.8125 9.65997 7.58583 9.65997 8.5325C9.6533 9.46583 8.91997 10.2258 7.99997 10.2525Z",
    stroke: "#1E729F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05998 12.3523C5.11998 12.9789 5.11998 14.0056 6.05998 14.6323C7.12665 15.3456 8.87331 15.3456 9.93998 14.6323C10.88 14.0056 10.88 12.9789 9.93998 12.3523C8.87998 11.6456 7.12665 11.6456 6.05998 12.3523Z",
    stroke: "#1E729F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/iconUsers.da1c08bb9fca2a345b9423c91643e89b.svg";
export { ForwardRef as ReactComponent };